import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { LeadPage, type LeadPageTab } from '@/features/leads/lead-page'
import { useAuth } from '@/hooks/use-auth'

type LeadPageSearch = {
  tab?: LeadPageTab
  inboxId?: string
}

const VALID_TABS = new Set<LeadPageTab>([
  'overview',
  'conversations',
  'appointments',
  'cadences',
  'history',
])

export const Route = createFileRoute('/_app/leads/$leadId')({
  validateSearch: (raw: Record<string, unknown>): LeadPageSearch => ({
    tab:
      typeof raw.tab === 'string' && VALID_TABS.has(raw.tab as LeadPageTab)
        ? (raw.tab as LeadPageTab)
        : undefined,
    inboxId: typeof raw.inboxId === 'string' ? raw.inboxId : undefined,
  }),
  component: LeadDetailPage,
})

function LeadDetailPage() {
  const { leadId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const { currentOrgId } = useAuth()

  if (!currentOrgId) return null

  return (
    <LeadPage
      leadId={leadId}
      orgId={currentOrgId}
      tab={search.tab ?? 'overview'}
      inboxId={search.inboxId}
      onTabChange={(tab) =>
        void navigate({
          search: (current) => ({
            ...current,
            tab: tab === 'overview' ? undefined : tab,
          }),
          replace: true,
        })
      }
    />
  )
}
